export default __webpack_public_path__ + "static/media/bogota.aca9e6c6.mp4";